export default "__VITE_ASSET__CSJNj3Eh__"